import {
  collection,
  query,
  onSnapshot,
  where,
  orderBy,
  doc,
  getDoc,
  getDocs,
  limit,
  startAfter,
  Timestamp,
} from "firebase/firestore";
import {
  deleteObject,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
} from "firebase/storage";
import {
  HEROKU_AUTHORIZATION,
  HEROKU_GET_USER_BY_DOC,
  HEROKU_GET_USER_INFO_BEFORE_LOGIN,
} from "./URLconsts";
import { COLLECTIONS } from "./consts";
import ToolHelper from "./ToolHelper";
// import audienceHelper from "./AudienceHelper";
import { parseISO } from "date-fns";

const now = Timestamp.now();

export default class DataHelper {
  constructor(app, db, getConfigFile) {
    this.app = app;
    this.db = db;

    getConfigFile(`utils/DataHelper/config.js`).then((importedFile) => {
      this.customCfg = importedFile?.default;
    });
  }

  setUserHelper(userHelper) {
    this.userHelper = userHelper;
  }

  setApiService(apiService) {
    this.api = apiService;
  }

  getList(snapshot) {
    let list = [];

    snapshot.forEach((doc) => {
      list.push({ ...doc.data(), id: doc.id });
    });

    return list;
  }

 async disableLogin(callback) {
    const disableLoginItem = doc(this.db, COLLECTIONS.APPSETTINGS, 'DisableLoginAvantiPremiado');

    let unsub = onSnapshot(disableLoginItem, async (snapshot) => {
      if (snapshot?.exists()) {
        let text = snapshot.data().TextValue__c
        callback(JSON.parse(text || "false"));
      } 
    })

    return { disableLogin: unsub }
  }

  getFilteredList = (snapshot, userAudience, fromChallenge = false) => {
    const list = [];

    snapshot?.forEach((doc) => {
      const docData = doc.data();
      docData.key = doc.id;
      docData.id = docData.Id;

      if (fromChallenge) {
        const isHowToEarnTargetGroup =
          !docData.HowToEarn__r?.TargetGroup__c ||
          (docData?.HowToEarn__r?.TargetGroup__c &&
            userAudience &&
            userAudience[docData.HowToEarn__r.TargetGroup__c]?.display);

        if (isHowToEarnTargetGroup) list.push(docData);
      } else {
        const isTargetGroup =
          !docData.TargetGroup__c ||
          (docData.TargetGroup__c &&
            userAudience &&
            userAudience[docData.TargetGroup__c]?.display);

        if (isTargetGroup) list.push(docData);
      }
    });

    return list;
  };

  sortList = (list) =>
    list.sort((a, b) => {
      // Verifica se ambos os elementos têm números
      if (!isNaN(parseFloat(a.Order__c)) && !isNaN(parseFloat(b.Order__c))) {
        return parseFloat(a.Order__c) - parseFloat(b.Order__c); // Ordena por número
      } else if (!isNaN(parseFloat(a.Order__c))) {
        return -1; // Coloca o número antes do texto
      } else if (!isNaN(parseFloat(b.Order__c))) {
        return 1; // Coloca o texto antes do número
      }

      return a.Name.localeCompare(b.Name);
    });

  async getCurrentSeason() {
    const currentSeason = await getDoc(
      doc(this.db, COLLECTIONS.APPSETTINGS, "CurrentSeason")
    );
    var data = currentSeason.data().TextValue__c;
    return data;
  }

  async snapPlayersSeason(callback) {
    const season = await this.getCurrentSeason();
    const seasonObj = JSON.parse(season);
    let playersQ = query(
      collection(this.db, "PlayerSeason"),
      where("Player__r.Active__c", "==", true),
      where("Season__c", "==", seasonObj.Id)
    );

    let unsub = onSnapshot(playersQ, async (snapshot) => {
      let players = this.getList(snapshot);
      callback(players);
    });

    return { players: unsub };
  }

  // exemplo
  // snapNews(callback, location) {
  //   let newsQ = query(
  //     collection(this.db, location.includes("/imprensa/") ? "Imprensa" : "News"),
  //     where("Active__c", "==", true),
  //     // where("Device__c", "in", ["Web", "All"]),
  //     where("IsApproved__c", "==", true),
  //     where("PublishDateTimestamp", "<=", now),
  //     orderBy("PublishDateTimestamp", "desc"),
  //     limit(9)
  //   );

  //   let unsub = onSnapshot(newsQ, (snapshot) => {
  //     let news = this.getList(snapshot);
  //     callback(news);
  //   });

  //   return { news: unsub };
  // }

  snapConfig(config, callback) {
    let configQ = query(collection(this.db, config.table));

    if (config.where?.length) {
      config.where.map((condition) => {
        configQ = query(
          configQ,
          where(condition[0], condition[1], condition[2])
        );
      });
    }

    if (config.order?.length) {
      config.order.map((order) => {
        configQ = query(configQ, orderBy(order[0], order[1]));
      });
    }

    let unsub = onSnapshot(configQ, (snapshot) => {
      let list = this.getList(snapshot);
      callback(list);
    });

    return unsub;
  }
  async getNews(qty = 10, startAfterDoc = null, isPreview = false) {
    let newsQ = query(
      collection(this.db, "News"),
      // where("Device__c", "in", ["Web", "All"]),
      where("PublishDateTimestamp", "<=", now),
      orderBy("PublishDateTimestamp", "desc"),
      limit(qty)
    );

    if (!isPreview) {
      newsQ = query(
        newsQ,
        where("Active__c", "==", true),
        where("IsApproved__c", "==", true)
      );
    }

    if (startAfterDoc) {
      newsQ = query(newsQ, startAfter(startAfterDoc));
    }
    let newsDoc = await getDocs(newsQ);

    let data = [];
    let lastDoc = null;

    if (newsDoc.docs.length) {
      data = newsDoc.docs.map((doc) => {
        lastDoc = doc;
        return doc.data();
      });
    }

    return { data, lastDoc };
  }

  async getPressNews(qty = 10, startAfterDoc = null) {
    let newsQ = query(
      collection(this.db, "Imprensa"),
      where("Active__c", "==", true),
      // where("Device__c", "in", ["Web", "All"]),
      where("PublishDateTimestamp", "<=", now),
      where("IsApproved__c", "==", true),
      orderBy("PublishDateTimestamp", "desc"),
      limit(qty)
    );

    if (startAfterDoc) {
      newsQ = query(newsQ, startAfter(startAfterDoc));
    }

    let newsDoc = await getDocs(newsQ);

    let data = [];
    let lastDoc = null;

    if (newsDoc.docs.length) {
      data = newsDoc.docs.map((doc) => {
        lastDoc = doc;
        return doc.data();
      });
    }

    return { data, lastDoc };
  }
  async getNewsByTeam(
    selectedTeam,
    qty = 10,
    startAfterDoc = null,
    isPreview = false
  ) {
    let newsQ = query(
      collection(this.db, "News"),
      // where("Device__c", "in", ["Web", "All"]),
      where("PublishDateTimestamp", "<=", now),
      orderBy("PublishDateTimestamp", "desc"),
      limit(qty)
    );

    if (!isPreview) {
      newsQ = query(
        newsQ,
        where("Active__c", "==", true),
        where("IsApproved__c", "==", true)
      );
    }

    if (selectedTeam !== "ALL") {
      newsQ = query(newsQ, where("Team__c", "==", selectedTeam));
    }

    if (startAfterDoc) {
      newsQ = query(newsQ, startAfter(startAfterDoc));
    }
    let newsDoc = await getDocs(newsQ);

    let data = [];
    let lastDoc = null;

    if (newsDoc.docs.length) {
      data = newsDoc.docs.map((doc) => {
        lastDoc = doc;
        return doc.data();
      });
    }

    return { data, lastDoc };
  }
  async getYTVideos(qty = 10, startAfterDoc = null, isPreview = false) {
    let newsQ = query(
      collection(this.db, "Youtube"),
      // where("Device__c", "in", ["Web", "All"]),
      where("PublishDateTimestamp", "<=", now),
      orderBy("PublishDateTimestamp", "desc"),
      limit(qty)
    );

    if (!isPreview) {
      newsQ = query(
        newsQ,
        where("Active__c", "==", true),
        where("IsApproved__c", "==", true)
      );
    }

    if (startAfterDoc) {
      newsQ = query(newsQ, startAfter(startAfterDoc));
    }
    let newsDoc = await getDocs(newsQ);

    let data = [];
    let lastDoc = null;

    if (newsDoc.docs.length) {
      data = newsDoc.docs.map((doc) => {
        lastDoc = doc;
        return doc.data();
      });
    }

    return { data, lastDoc };
  }
  // async getArticle(articleId, isPreview = false, isRelease = false) {
  //   let articleDoc;

  //   let defaultArticleFullPath = NEWS_ARTICLE_URL.replace(
  //     "[ARTICLEID]",
  //     articleId
  //   );
  //   let alternativeArticleFullPath = NEWS_ALTERNATIVE_URL.replace(
  //     "[ARTICLEID]",
  //     articleId
  //   );

  //   let siteAlternativeArticleFullPath = NEWS_SITE_ALTERNATIVE__URL.replace(
  //     "[ARTICLEID]",
  //     articleId
  //   );

  //   let articleQ = query(
  //     collection(this.db, isRelease ? "Imprensa" : "News"),
  //     where("Url__c", "in", [
  //       defaultArticleFullPath,
  //       alternativeArticleFullPath,
  //       siteAlternativeArticleFullPath,
  //     ])
  //   );

  //   if (!isPreview) {
  //     articleQ = query(
  //       articleQ,
  //       where("Active__c", "==", true),
  //       where("IsApproved__c", "==", true),
  //       where("PublishDateTimestamp", "<=", now)
  //     );
  //   }

  //   let deviceDocs = await getDocs(articleQ);
  //   let deviceResults = deviceDocs?.docs;

  //   let filteredResults = deviceResults.filter((doc) => {
  //     let data = doc.data();

  //     // return ["Web", "All"].includes(data?.Device__c);
  //     return data;
  //   });

  //   if (filteredResults?.length) {
  //     articleDoc = filteredResults[0];
  //   }

  //   if (articleDoc) {
  //     return articleDoc.data();
  //   }

  //   return false;
  // }
  async getAppSettingText(textName, callback) {
    let textQ = doc(this.db, "AppSetting", textName);
    let textDoc = await getDoc(textQ);

    if (textDoc?.exists() && textDoc?.data()["TextValue__c"]) {
      callback(textDoc.data()["TextValue__c"]);
    } else {
      callback("");
    }
  }

  async audienceTypeValidation(id, user) {
    let audiencesQ = query(
      collection(this.db, "AudienceType"),
      where("Id", "==", id)
    );
    let audienceDocs = await getDocs(audiencesQ);

    const userCTG = await this.userHelper.getCTGUser();

    const compare = (record) => {
      let ret = false;
      if (record.Type__c === "Campaign" && userCTG) {
        let hasCampaing = userCTG.filter(
          (ctg) => ctg.CampaignId === record.Campaign__c
        );
        if (hasCampaing && hasCampaing.length > 0) {
          ret = true;
        }
      } else if (record.Type__c === "Field") {
        if (record.Comparator__c === "=") {
          if (user[record.Field__c] === record.Value__c) {
            ret = true;
          }
        } else if (record.Comparator__c?.toString().toLowerCase() === "in") {
          let values = record.Value__c?.split(";");
          let userProfiles = user.acg_LoyaltyProfiles__c?.split(";");
          if (values) {
            for (let idx in values) {
              if (userProfiles?.includes(values[idx])) {
                ret = true;
                break;
              }
            }
          }
        }
      }

      return ret;
    };

    if (audienceDocs.docs.length) {
      let audienceDoc = audienceDocs.docs[0].data();
      let ret = false;

      if (!audienceDoc.AudienceTypeCriterias__r?.records) {
        return ret;
      }

      if (audienceDoc.CriteriaType__c === "OR") {
        audienceDoc.AudienceTypeCriterias__r?.records.forEach((x) => {
          if (compare(x)) {
            ret = true;
            return;
          }
        });
      } else {
        ret = true;
        audienceDoc.AudienceTypeCriterias__r?.records.forEach((x) => {
          if (!compare(x)) {
            ret = false;
            return;
          }
        });
      }
      return ret;
    }
  }

  async getTermsText(callback) {
    this.getAppSettingText("TermsOfService", callback);
  }
  async getLoyaltyCategories(callback){
    this.getAppSettingText("LoyaltyCategories", callback);
  }

  async getHerokuDomainApi() {
    let urlQ = doc(this.db, "AppSetting", "HerokuApi");
    let urlDoc = await getDoc(urlQ);

    if (urlDoc.exists() && urlDoc.data().TextValue__c) {
      const { url, token } = JSON.parse(urlDoc.data().TextValue__c || "{}");

      return { url, token };
    }

    return false;
  }

  async getHerokuDomain() {
    let urlQ = doc(this.db, "AppSetting", "HerokuUrl");
    let urlDoc = await getDoc(urlQ);

    if (urlDoc.exists() && urlDoc.data().TextValue__c) {
      return urlDoc.data().TextValue__c;
    }

    return false;
  }

  async getHerokuUrl(path, isRest = true) {
    if (!global.herokuDomain) {
      global.herokuDomain = await this.getHerokuDomain();
    }

    let url = "";

    if (global.herokuDomain) {
      url = global.herokuDomain;

      if (isRest) {
        url += "/restHelper";
      }

      url += path;
    }

    return url;
  }

  getHerokuUrlV2(path, isRest = true) {
    let url = "";

    if (isRest) {
      url += "/restHelper";
    }

    url += path;

    return url;
  }

  async loadCurrentSeasonId() {
    let seasonQ = doc(this.db, "AppSetting", "CurrentSeason");
    let seasonDoc = await getDoc(seasonQ);

    let season = "";

    if (seasonDoc.exists() && seasonDoc.data().TextValue__c) {
      season = JSON.parse(seasonDoc.data().TextValue__c)?.Id;
    }

    global.season = season;

    return season;
  }
  async uploadImage(img, path, imageId) {
    const storage = getStorage();
    const storageRef = ref(storage, `${path}/${imageId}.jpeg`);
    const metadata = { contentType: "image/jpeg" };

    const snapshot = await uploadBytes(storageRef, img, metadata);
    const url = await getDownloadURL(storageRef);

    return url;
  }

  async deleteImage(path, imageId) {
    const storage = getStorage();
    const storageRef = ref(storage, `${path}/${imageId}.jpeg`);

    try {
      await deleteObject(storageRef);
      return true;
    } catch (e) {
      console.log("erro deletando imagem!", e);
      return false;
    }
  }

  dateDisplayFormat(date) {
    if (date?.length && date?.search("-") !== -1) {
      return date.split("-").reverse().join("/");
    }

    return date;
  }

  appScreenToUrl(routes, appScreen) {
    switch (appScreen) {
      case "Profile":
        return routes.profile.path;
      case "Survey":
        return routes.survey.path;
      case "ReceiptHistory":
        return routes.home.path;
      default:
        return routes.home.path;
    }
  }

  nl2br(str, is_xhtml) {
    if (typeof str === "undefined" || str === null) {
      return "";
    }
    var breakTag =
      is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>";
    return (str + "").replace(
      /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
      "$1" + breakTag + "$2"
    );
  }

  docsToArray(elDocs) {
    let data = [];

    if (elDocs.docs.length) {
      data = elDocs.docs.map((doc) => {
        return doc.data();
      });
    }

    return data;
  }
  userByDoc = async (doc) => {
    if (!doc) {
      return false;
    }

    const getUserUrl = await this.getHerokuUrl(
      `${HEROKU_GET_USER_BY_DOC}/${doc}`,
      false
    );

    try {
      let response = await fetch(getUserUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: HEROKU_AUTHORIZATION,
        },
      });

      if (response.ok) {
        const parsedResponse = await response.json();
        return parsedResponse;
      } else {
        return { message: "erro ao trazer usuário!", error: true };
      }
    } catch (e) {
      console.log("error", JSON.stringify(e));
      return false;
    }
  };

  async hasActiveProfiles(userGroupId) {
    if (!userGroupId) {
      return false;
    }

    const profiles = await this.getProfilesByUserGroup(userGroupId);

    if (profiles && profiles?.length) {
      return profiles.some(
        (u) => !["Inativo", "Blocked"].includes(u.acg_Status__c)
      );
    }

    return false;
  }

  async getUserInfoBeforeLogin(firebaseId) {
    if (!firebaseId) {
      return false;
    }

    const getUserInfoBeforeLoginUrl = await this.getHerokuUrl(
      `${HEROKU_GET_USER_INFO_BEFORE_LOGIN}/${firebaseId}`,
      false
    );

    try {
      const response = await fetch(getUserInfoBeforeLoginUrl, {
        method: "GET",
        headers: {
          Authorization: HEROKU_AUTHORIZATION,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      const result = JSON.parse(JSON.stringify(data));
      return result;
    } catch (error) {
      return false;
    }
  }

  async snapStartUpMessages() {
    let elQ = query(
      collection(this.db, "StartUpMessages"),
      where("Active__c", "==", true),
      orderBy("Priority__c", "asc")
    );
    let elDoc = await getDocs(elQ);

    let data = [];

    if (elDoc.docs.length) {
      data = elDoc.docs.map((doc) => {
        return doc.data();
      });
    }

    return { data };
  }

  // async getHeaderMessage() {
  //   var currentDateTime = ToolHelper.getISO8601Date();

  //   // Firebase não deixa filtrar duas inequalidades em campos diferentes.
  //   // Por isso é filtrado apenas data futura. A data de início é filtrada localmente
  //   let elQ = query(
  //     collection(this.db, "StartUpMessages"),
  //     where("ScreenType__c", "==", "Site Header"),
  //     where("EndDateTime__c", ">=", currentDateTime),
  //     orderBy("EndDateTime__c", "asc"),
  //     orderBy("Priority__c", "asc")
  //   );

  //   let elDoc = await getDocs(elQ);

  //   let data;

  //   if (elDoc.docs.length) {
  //     elDoc.docs.forEach((doc) => {
  //       let docData = doc.data();

  //       if (docData.StartDateTime__c <= currentDateTime) {
  //         // Se houver mais de um substitui. E isso está ok pois Priority__c maior é mais prioritário
  //         data = docData;
  //       }
  //     });
  //   }

  //   return data;
  // }

  async getSocialMedias(category = "Masc") {
    let mediasRef = doc(this.db, "AppSetting", "SocialMediaCategoriesSettings");
    let mediasDoc = await getDoc(mediasRef);
    let result = [];

    if (mediasDoc.exists()) {
      let text = mediasDoc.data().TextValue__c;

      let obj = JSON.parse(text);
      result = obj[category];
    }

    return result;
  }

  async getTeamTitles(category = "Título", highlighted = false) {
    let titles;

    if (!highlighted) {
      titles = query(
        collection(this.db, "Achievement"),
        where("Category__c", "==", category)
      );
    } else {
      titles = query(
        collection(this.db, "Achievement"),
        where("Category__c", "==", category),
        where("Highlighted__c", "==", highlighted)
      );
    }

    const titlesDoc = await getDocs(titles);

    let data = [];

    if (titlesDoc.docs.length) {
      data = titlesDoc.docs.map((doc) => {
        const titles = doc.data();
        const [year] = titles?.Date__c?.split("-");
        const fullDate = parseISO(`${year}-07-01T00:00:00.000Z`);
        return { ...titles, year, fullDate };
      });
    }

    return data;
  }

  async getCaseSettings() {
    let caseSettingsRef = doc(this.db, "AppSetting", "CaseSettings");
    let caseSettingsDoc = await getDoc(caseSettingsRef);
    let result = {};

    if (caseSettingsDoc.exists()) {
      let text = caseSettingsDoc.data().TextValue__c;
      let obj = JSON.parse(text);
      result = obj;
    }

    return result;
  }

  // async getEvents(selectedTeam = "CRU", qtyPast = 2, qtyFuture = 5) {
  //   let elQ = query(collection(this.db, "Event"));

  //   switch (selectedTeam) {
  //     case "BASE":
  //     case "CRUBASE":
  //       elQ = query(elQ, where("Team__c", "in", ["CRU17", "CRU20"]));
  //       break;
  //     case "ALL":
  //       break;
  //     default:
  //       elQ = query(elQ, where("Team__c", "==", selectedTeam));
  //   }

  //   // Buscando primeiro 2 eventos passados
  //   var currentDateTime = ToolHelper.getISO8601Date();
  //   let elQPast = query(
  //     elQ,
  //     where("EventDate__c", "<", currentDateTime),
  //     orderBy("EventDate__c", "desc"),
  //     limit(qtyPast)
  //   );

  //   let elDocPast = await getDocs(elQPast);

  //   let data = [];

  //   if (elDocPast.docs.length) {
  //     elDocPast.docs.forEach((doc) => {
  //       let docData = doc.data();
  //       data.push(docData);
  //     });

  //     data = data.reverse();
  //   }

  //   // Agora busca 5 eventos futuros
  //   let elQFuture = query(
  //     elQ,
  //     where("EventDate__c", ">=", currentDateTime),
  //     orderBy("EventDate__c", "asc"),
  //     limit(qtyFuture)
  //   );

  //   let elDocFuture = await getDocs(elQFuture);

  //   if (elDocFuture.docs.length) {
  //     elDocFuture.docs.forEach((doc) => {
  //       let docData = doc.data();
  //       data.push(docData);
  //     });
  //   }

  //   return data;
  // }

  // async getEventsSnapshot(
  //   selectedTeam = "CRU",
  //   qtyPast = 2,
  //   qtyFuture = 5,
  //   callback
  // ) {
  //   let elQ = query(collection(this.db, "Event"));

  //   switch (selectedTeam) {
  //     case "BASE":
  //     case "CRUBASE":
  //       elQ = query(elQ, where("Team__c", "in", ["CRU17", "CRU20"]));
  //       break;
  //     case "ALL":
  //       break;
  //     default:
  //       elQ = query(elQ, where("Team__c", "==", selectedTeam));
  //   }

  //   var currentDateTime = ToolHelper.getISO8601DatePlusHours(6);

  //   let unsubs = [];
  //   let pastEvents = [];
  //   let futureEvents = [];

  //   // Past events listener
  //   let elQPast = query(
  //     elQ,
  //     where("EventDate__c", "<", currentDateTime),
  //     orderBy("EventDate__c", "desc"),
  //     limit(qtyPast)
  //   );

  //   let elDocPastUnsub = onSnapshot(elQPast, (snapshot) => {
  //     pastEvents = [];
  //     if (!snapshot.empty) {
  //       snapshot.docs.forEach((doc) => {
  //         let docData = doc.data();
  //         pastEvents.push(docData);
  //       });
  //       pastEvents = pastEvents.reverse();
  //     }
  //     // Combine past and future events and call the callback
  //     const data = [...pastEvents, ...futureEvents];
  //     callback(data);
  //   });
  //   unsubs.push(elDocPastUnsub);

  //   // Future events listener
  //   let elQFuture = query(
  //     elQ,
  //     where("EventDate__c", ">=", currentDateTime),
  //     orderBy("EventDate__c", "asc"),
  //     limit(qtyFuture)
  //   );

  //   let elDocFutureUnsub = onSnapshot(elQFuture, (snapshot) => {
  //     futureEvents = [];
  //     if (!snapshot.empty) {
  //       snapshot.docs.forEach((doc) => {
  //         let docData = doc.data();
  //         futureEvents.push(docData);
  //       });
  //     }
  //     // Combine past and future events and call the callback
  //     const data = [...pastEvents, ...futureEvents];
  //     callback(data);
  //   });
  //   unsubs.push(elDocFutureUnsub);

  //   return unsubs;
  // }

  async getEventById(eventId, callback) {
    const eventRef = doc(this.db, "Event", eventId);

    const unsub = onSnapshot(eventRef, async (snapshot) => {
      if (snapshot?.exists()) {
        let event = snapshot.data();
        callback(event);
      } else {
        console.log("eventos não encontrado");
        callback({});
      }
    });

    return unsub;
  }

  // recebe CRU, retorna CRU
  // recebe CRUFEM, retorna CRU
  // recebe PAL, retorna PAL
  defaultTeamCode(teamCode) {
    if (!teamCode?.length) return "";

    return teamCode.startsWith("CRU") ? "CRU" : teamCode;
  }

  async getContent(contentId) {
    // Busca conteúdo pelo path
    let caseSettingsRef = doc(this.db, "Article", contentId);
    let caseSettingsDoc = await getDoc(caseSettingsRef);
    let result = {};

    if (caseSettingsDoc.exists()) {
      result = caseSettingsDoc.data();
    }

    return result;
  }

  async snapMenuItems(callback) {
    let menuItemsQ = query(
      collection(this.db, "MenuItem"),
      orderBy("Order__c", "asc")
    );

    let unsub = onSnapshot(menuItemsQ, async (snapshot) => {
      let menuItems = this.getList(snapshot);

      callback(menuItems);
    });

    return { menuItems: unsub };
  }

  async getKnowledges(callback, type) {
    const userData = await this.userHelper.getUser();
    let knowledgeRef;
    if (userData?.LoyaltyCategory__c === "Staff") {
      knowledgeRef = query(
        collection(this.db, "Knowledges"),
        where("Category__c", "==", "Avanti Premiado"),
        where("IsVisibleInCsp", "==", true)
      );
    } else {
      try {
        knowledgeRef = query(
          collection(this.db, "Knowledges"),
          where("Category__c", "==", "Avanti Premiado"),
          where("PublishStatus__c", "==", "Live"),
          where("Language", "==", "pt_BR"),
          where("IsVisibleInCsp", "==", true)
        );
      } catch (error) {
        console.log("error", error);
      }
    }

    let unsub = onSnapshot(knowledgeRef, async (snapshot) => {
      callback(snapshot);
    });

    return { knowledge: unsub };
  }

  async getMidiaSettings() {
    let midiaSettingsRef = await getDoc(
      doc(this.db, COLLECTIONS.APPSETTINGS, "MidiaSettings")
    );
    let data = midiaSettingsRef.data().TextValue__c;
    return JSON.parse(data);
  }

  getEventsDoc(eventId) {
    const eventDoc = doc(this.db, COLLECTIONS.EVENTS, eventId);
    return eventDoc;
  }

  getQuizCollection(eventId) {
    const quizDoc = query(
      collection(this.db, COLLECTIONS.QUIZ),
      where("Event__c", "==", eventId),
      orderBy("TimeOrderBy__c", "desc")
    );
    return quizDoc;
  }

  snapAds(callback, audienceTypes) {
    let adsQ = query(collection(this.db, COLLECTIONS.ADS));

    let unsub = onSnapshot(adsQ, (snapshot) => {
      let ads = this.getFilteredList(snapshot, audienceTypes);

      callback(ads);
    });

    return { ads: unsub };
  }

  async snapKnowledgesLoyalty(callback) {
    const userData = await this.userHelper.getUser();
    let knowledgeRef =
      userData?.LoyaltyCategory__c === "Staff"
        ? query(
            collection(this.db, "Knowledges"),
            where("Category__c", "==", "Loyalty")
            // where("IsVisibleInCsp", "==", true)
          )
        : query(
            collection(this.db, "Knowledges"),
            where("Category__c", "==", "Loyalty"),
            where("PublishStatus__c", "==", "Live"),
            where("Language", "==", "en_US")
            // where("IsVisibleInCsp", "==", true)
          );

    let unsub = onSnapshot(knowledgeRef, async (snapshot) => {
      const results = this.getList(snapshot);
      callback(results);
    });

    return { knowledge: unsub };
  }

  snapHowToEarn(callback, audienceTypes) {
    let howToEarnQ = query(
      collection(this.db, COLLECTIONS.HOW_TO_EARN, "/SimplePoint/records")
    );

    let unsub = onSnapshot(howToEarnQ, (snapshot) => {
      const { loginStreak, howToEarnList } = this.getFilteredList(
        snapshot,
        audienceTypes
      ).reduce(
        (acc, curr) => {
          if (
            [
              "Daily Login",
              "Daily Login - Partial",
              "Daily Login - Full",
            ].includes(curr.DisplaySection__c)
          ) {
            acc.loginStreak.push(curr);
          } else {
            acc.howToEarnList.push(curr);
          }

          return acc;
        },
        { howToEarnList: [], loginStreak: [] }
      );

      callback({
        loginStreak,
        lstHowToEarn: howToEarnList.sort((a, b) => {
          if (
            a.Order__c ||
            b.Order__c ||
            a.Order__c === 0 ||
            b.Order__c === 0
          ) {
            if (a.Order__c < b.Order__c) return -1;
            if (a.Order__c > b.Order__c) return 1;

            return 0;
          }

          if (a.HowToEarn__r.Name < b.HowToEarn__r.Name) return -1;
          if (a.HowToEarn__r.Name > b.HowToEarn__r.Name) return 1;

          return 0;
        }),
      });
    });

    return { howToEarn: unsub };
  }

  snapTrails(callback, audienceTypes) {
    let TrailQ = query(
      collection(this.db, COLLECTIONS.HOW_TO_EARN, "/Trail/records")
    );

    let unsub = onSnapshot(TrailQ, (snapshot) => {
      const allTempTrailChallenges = this.getList(snapshot);
      const allChallenges = this.getFilteredList(snapshot, audienceTypes).map(
        (challenge) => ({
          ...challenge,
          isTrail: true,
        })
      );

      callback({ allTempTrailChallenges, allChallenges });
    });

    return { Trail: unsub };
  }

  snapProgressChallenges(callback, audienceTypes) {
    let ProgressQ = query(
      collection(this.db, COLLECTIONS.HOW_TO_EARN, "/Progress/records"),
      where("Active__c", "==", true)
    );

    let unsub = onSnapshot(ProgressQ, (snapshot) => {
      const allTempProgChallenges = this.getList(snapshot);
      const allChallenges = this.getFilteredList(snapshot, audienceTypes);

      callback({ allTempProgChallenges, allChallenges });
    });

    return { rewards: unsub };
  }
  snapRewards(callback) {
    let RewardsQ = query(
      collection(this.db, COLLECTIONS.REWARDS),
      where("IsActive", "==", true)
    );
    let unsub = onSnapshot(RewardsQ, (snapshot) => {
      const rewards = this.getList(snapshot);
      callback(rewards);
    });

    return { rewards: unsub };
  }
  async loadTrailsRecords(docId) {
    let TrailQ = query(
      collection(
        this.db,
        COLLECTIONS.HOW_TO_EARN,
        "/Trail/records",
        docId,
        "records"
      )
    );
    let TrailDocs = await getDocs(TrailQ);
    let results = this.getList(TrailDocs);

    return results;
  }

  snapAllSweepstakes(audienceTypes, callback) {
    let sweepstakeDoc = query(
      collection(this.db, COLLECTIONS.SWEEPSTAKE),
      where("IsActive", "==", true)
    );

    let unsub = onSnapshot(sweepstakeDoc, (snapshot) => {
      const filteredSweepstakes = this.getFilteredList(snapshot, audienceTypes);

      callback(filteredSweepstakes || []);
    });

    return { sweepstakes: unsub };
  }

  async snapPointStatement(lstProductsIds, callback) {
    if (lstProductsIds && lstProductsIds?.length > 0) {
      const userFirebaseId = await this?.userHelper?.getUserFirebaseId();

      let pointStatementDoc = query(
        collection(
          this.db,
          COLLECTIONS.USERS,
          userFirebaseId,
          COLLECTIONS.POINTS
        ),
        where("ProductItem__c", "in", lstProductsIds.slice(0, 10))
      );

      let unsub = onSnapshot(pointStatementDoc, (snapshot) => {
        const pointStatement = this.getList(snapshot);

        callback(pointStatement || []);
      });

      return unsub;
    } else {
      callback([]);
    }
  }

  snapBadgesGroups(callback) {
    let BadgeGroupQ = query(
      collection(this.db, COLLECTIONS.BADGESGROUP),
      where("Active__c", "==", true)
    );

    let unsub = onSnapshot(BadgeGroupQ, (snapshot) => {
      const badgeGroups = this.sortList(this.getList(snapshot));

      callback(badgeGroups);
    });

    return { BadgeGroup: unsub };
  }

  snapBenefits(callback) {
    let BenefitsQ = query(collection(this.db, COLLECTIONS.BENEFITS));

    let unsub = onSnapshot(BenefitsQ, (snapshot) => {
      const benefits = this.sortList(this.getList(snapshot));

      callback(benefits);
    });

    return { Benefits: unsub };
  }

  snapBadges(callback, Id, audienceTypes) {
    const badgeGroupId = Id ? Id.slice(0, 15) : null;

    let BadgesQ = query(
      collection(
        this.db,
        COLLECTIONS.BADGESGROUP,
        badgeGroupId,
        COLLECTIONS.BADGES
      ),
      where("Active__c", "==", true)
    );

    let unsub = onSnapshot(BadgesQ, (snapshot) => {
      const allBadges = this.getList(snapshot);
      const badges = this.getFilteredList(snapshot, audienceTypes);

      callback({ allBadges, badges });
    });

    return unsub;
  }
}
